import { makeStyles } from "@mui/styles";
import { darkPalette } from "helpers/themeColors";

export const accordionStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
    color: '#004F9F',
    width: '100%',
    marginRight: 5
  },
  border: {
    borderRadius: 6,
    marginBottom: 4,
  },
  bad: {
    background: ({ isDark }) => isDark
      ? `linear-gradient(125deg, ${darkPalette.altRowBg} 90%, rgba(246,104,94,0.6) 100%)`
      : 'linear-gradient(125deg, rgba(238, 238, 238 ,1) 90%, rgba(246,104,94,1) 100%)'
  },
  good: {
    background: ({ isDark }) => isDark
      ? `linear-gradient(125deg, ${darkPalette.altRowBg} 90%, rgba(76, 175, 80, 0.6) 100%)`
      : 'linear-gradient(125deg, rgba(238, 238, 238 ,1) 90%, rgb(165, 255, 168) 100%)'
  },
  box: {
    width: '100%',
    display: 'flex',
  },
  text: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 4,
    marginRight: 20
  },
  scrollBox: {
    maxHeight: 400,
    overflowY: 'scroll'
  }
}));